import type { AxiosInstance } from 'axios';
import { treatRecoveryPlan } from 'shared/serializer';
import type { RecoveryPlan } from 'types/recovery-plan';

type FetchRecoveryPlanStepsParams = {
  id: string;
  companyDefault?: boolean;
};

// The step-mapping modal still works on the legacy plan shape, so the full
// plan is read from the legacy endpoint only when that modal opens.
export async function fetchRecoveryPlanSteps(
  axiosInstance: Promise<AxiosInstance>,
  { id, companyDefault }: FetchRecoveryPlanStepsParams,
): Promise<RecoveryPlan> {
  const instance = await axiosInstance;
  const params = companyDefault ? { company_default: true } : {};
  const { data } = await instance.get(`/recovery_plans/${id}`, { params });

  return treatRecoveryPlan(data.data);
}
